export const countryCodes = [
  {
    code: "+91",
    country: "India",
    label: "India (+91)"
  }
];

export const defaultCountryCode = "+91";
